export default __webpack_public_path__ + "static/media/manleva.b30c48ab.pdf";